import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {contact} from 'config/translate/variables'
import PubSub from 'services/PubSub/';
import LoginService from 'services/Login/';
import StorageService from 'services/StorageService';
import AddressService from 'services/Address';
import Loader from 'components/Loader';
import TagManagerService from 'services/TagManager';
import { actionsType } from 'config/constants';
import NewRelicService from 'services/NewRelic'
import style from './style.scss'; //NOSONAR

let accessKey = null;
let orderFormId = null;
let genericValidate = null;

const ValidationCodeCheckout = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [inputIsValid, setInputIsValid] = useState(false)
    const [showInvalidInput, setShowInvalidInput] = useState(false)
    const [email, setEmail] = useState('')
    const [incorrectCode, setIncorrectCode] = useState(false)
    const [addressId, setAddressId] = useState(false)

    let formMessage = 'Campo obligatorio'
    let codeIncorrectMessage = 'La clave de acceso no es válida. Verifica el código'
    
    const userData = StorageService.getSecureItem('userData')

    const _open = (payload) => {
        setEmail(userData.email)
        LoginService.sendUserAccessKey(userData.email);
        setAddressId(payload.value.addressId);
        orderFormId = payload.value.orderFormId;
        TagManagerService.interaction('Impression',orderFormId, 'Token Modal');
        genericValidate = payload.value.genericValidate
    }

    useEffect(() => {
        const { payload } = props

        if (payload) {
            _open(payload)
        }
    }, [props.payload])

    const _close = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.VALIDATION_CODE_CHECKOUT_CLOSE), 0);
        orderFormId = null;
    }

    const goBack = () => {
        TagManagerService.interaction('Click: Volver', orderFormId, 'Token Modal')
        _close()
    }

    const handleChange = (event) => {
        const value = event.target.value
        if (value.length >= 6) {
            setInputIsValid(true)
            setShowInvalidInput(true)

            accessKey = value
        } else {
            setInputIsValid(false)
            setShowInvalidInput(false)
        }
    }

    const _sendPageEvent = (status = '') => {
        NewRelicService.sendPageAction({
            action: 'modalValidationAddress',
            payload: {
                status: status
            }
        })
    }

    const submit = (event) => {
        event.preventDefault()

        if (!(inputIsValid && accessKey)) return false

        setIsLoading(true)
        
        if(genericValidate){
            LoginService.validateUserAccessKey(email, accessKey).then(results => {
                if(results && results.authStatus === 'Success'){
                    PubSub.dispatch('validate_toke_account_bank');
                    _close();
                }else {
                    setIncorrectCode(true); 
                }
                setIsLoading(false);
            })
        }else {
            TagManagerService.interaction('Click: Confirmar', orderFormId, 'Token Modal');
            AddressService.validateAddress(addressId, accessKey)
                .then(data => {
                    if(data && data.status && data.status === 200) {
                        _sendPageEvent('success');
                        PubSub.dispatch('RETRY_PURCHASE')
                        _close()
                        setIncorrectCode(false)
                        TagManagerService.interaction('Código correcto', orderFormId, 'Token Modal')
                    } else {
                        _sendPageEvent('incorrectCode');
                        setIncorrectCode(true)
                    }
                    setIsLoading(false)
                })
        }

        
    }

    const resendCode = () => {
        _sendPageEvent('resendCode');
        LoginService.sendUserAccessKey(email).then(() => {
            setIsLoading(false);
            setTimeout(() => {
                PubSub.dispatch('open_snackbar', {
                    TitleMobile: 'Hemos reenviado el código a tu mail',
                    TitleDesktop: `Hemos reenviado el código a tu mail`,
                    timer: 8000,
                    type: 'resendCode',
                });
            }, 0)
        })
    }

    return (
        <div className="new-modal-container">
            <div className="new-modal-title-wrap"><h3 className="new-modal-title">Ingresa tu código</h3></div>
            <div className={'new-modal-scroll'}>
                {isLoading && (
                    <div className="login-validation-code-loader">
                        <Loader />
                    </div>
                )}
                <form className="input-wrapper-validation" onSubmit={submit}>
                    <label className="label-validation">
                        <div className="label-text-validation">
                            Para finalizar, <br />
                            ingresa el código enviado a tu correo:
                        </div>
                        <div className="label-mail-validation">{email}</div>
                    </label>
                    <div className="contact-validation-container">
                        <span className="validation-title">Código</span>
                        <input
                            onChange={handleChange}
                            className={'input-validation ' + (incorrectCode || !(inputIsValid || !showInvalidInput) ? 'is-error' : '')}
                            placeholder={'Eje: 12345'}
                        />
                    </div>
                    {inputIsValid || !showInvalidInput ? '' : <p className="input-error">{formMessage}</p>}
                    {!(incorrectCode && !showInvalidInput) ? '' : <p className="input-error">{codeIncorrectMessage}</p>}
                    <div className="contact-validation-resend">No me llegó el código <a className="new-link contact-validation-code" onClick={resendCode}>Reenviar</a></div>
                    <div className="contact-validation">Si tienes cualquier problema, contáctate al <a className="contact-validation-number">{contact.phone}</a></div>
                </form>
            </div>
            <div className="modal-actions">
                <button
                    type="button"
                    className="secundary-btn"
                    onClick={goBack}>
                    <span>Volver</span>
                </button>
                <button
                    type="submit"
                    onClick={submit}
                    className={inputIsValid ? 'primary-btn' : 'disabled-btn'}>
                    <span className="modal-validation-code-change-pasword">
                        Confirmar
                    </span>
                </button>
            </div>
        </div>
    )
}

ValidationCodeCheckout.propTypes = {
    payload: PropTypes.object,
}

export default ValidationCodeCheckout
